var _circle, _circle2, _circle3, _g, _path, _path2, _rect, _g2, _ellipse, _ellipse2, _path3, _path4, _g3, _path5, _path6, _path7, _path8, _path9, _path10, _circle4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChristmasScribbles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 112,
    viewBox: "0 0 112 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_622_3",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 112,
    height: 112
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 55.5183,
    cy: 56.0486,
    r: 55.5,
    fill: "#C4C4C4"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_622_3)"
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 55.5183,
    cy: 56.0486,
    r: 55.5,
    fill: "#ECFDF5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_622_3",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 112,
    height: 112
  }, _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 55.5183,
    cy: 56.0486,
    r: 55.5,
    fill: "#FFFBEB"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_622_3)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.2913 118.741C100.791 117.944 104.275 120.135 105.073 123.635C107.853 135.833 115.822 141.124 124.911 146.592C125.233 146.786 125.56 146.982 125.892 147.181C129.981 149.63 134.716 152.468 138.258 156.149C142.486 160.545 145.139 166.204 144.654 173.768C144.175 181.239 140.22 186.802 135.018 190.678C129.979 194.432 123.602 196.771 117.341 198.27C104.785 201.275 90.6794 201.362 82.8561 200.88C79.273 200.66 76.5471 197.577 76.7676 193.993C76.9881 190.41 80.0715 187.684 83.6546 187.905C90.7985 188.345 103.488 188.218 114.315 185.627C119.746 184.327 124.207 182.521 127.25 180.254C130.129 178.108 131.499 175.772 131.68 172.936C131.909 169.373 130.848 167.198 128.888 165.161C126.593 162.775 123.277 160.781 118.599 157.966C118.47 157.889 118.34 157.81 118.209 157.732C108.94 152.155 96.4799 144.436 92.3979 126.523C91.6004 123.023 93.7912 119.539 97.2913 118.741Z",
    fill: "url(#paint0_linear_622_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.5256 203.731L35.1609 207.57C35.1609 207.57 18.1986 188.823 19.6731 165.694C21.5758 135.849 34.5335 72.2781 34.5335 72.2781L72.8198 69.5748C72.8198 69.5748 86.8446 116.065 95.7622 157.176C101.379 183.071 89.5256 203.731 89.5256 203.731Z",
    fill: "url(#paint1_linear_622_3)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.8241 78.4843L70.806 75.7319C70.806 75.7319 82.3123 87.3717 83.4671 103.727C84.11 112.832 81.7402 126.163 79.5127 136.193L72.975 196.036C76.3247 202.043 75.8254 203.043 73.7127 206.485L63.6847 207.193C61.2608 204.124 60.3114 202.597 64.0027 195.786C63.8983 192.092 63.801 188.579 63.7079 185.217C63.3914 173.789 63.1234 164.108 62.7869 154.997C61.1063 155.421 59.4531 155.73 57.9562 155.836C56.4702 155.941 54.7957 155.869 53.073 155.69L57.3258 196.294C61.6594 201.217 60.8554 203.484 59.6126 206.989C59.552 207.16 59.4904 207.333 59.4283 207.51L50.5804 208.135C50.3601 207.954 50.1492 207.784 49.9486 207.622C47.4015 205.572 46.4953 204.843 48.5037 197.948C47.6201 194.359 46.7818 190.946 45.9796 187.68C41.5936 169.824 38.2865 156.361 34.5463 142.6C30.225 132.444 24.2562 117.018 23.6161 107.953C22.9162 98.0407 31.8241 78.4843 31.8241 78.4843Z",
    fill: "url(#paint2_linear_622_3)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.0886 36.6366C86.7192 35.547 67.4466 48.08 67.4466 48.08C64.5189 46.8979 61.5436 45.9894 58.7915 45.6519C54.3406 45.106 49.0939 45.8845 44.1603 47.124C44.1603 47.124 26.7999 34.0718 24.7614 35.4271C22.7228 36.7825 27.0493 54.9376 27.0493 54.9376L27.5269 76.8904C30.3294 88.4034 54.0831 97.5306 54.0831 97.5306C54.0831 97.5306 77.9534 92.7183 82.3415 82.3085L84.9818 60.1452C84.9818 60.1452 91.4579 37.7263 89.0886 36.6366Z",
    fill: "url(#paint3_linear_622_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6006 73.4436C50.0876 76.1618 47.3972 73.8384 44.679 74.3254C41.9609 74.8124 40.2444 77.9253 39.7574 75.2072C39.2704 72.489 41.3436 71.3672 44.0618 70.8802C46.7799 70.3933 49.1137 70.7255 49.6006 73.4436Z",
    fill: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.0004 76.9139C70.1889 79.5534 68.8607 76.2561 66.2212 75.4446C63.5817 74.6332 60.6305 76.6148 61.4419 73.9753C62.2534 71.3358 64.6102 71.2877 67.2497 72.0992C69.8892 72.9106 71.8119 74.2744 71.0004 76.9139Z",
    fill: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.9986 85.5786C55.3961 86.0895 56.1667 86.0939 56.57 85.5877L59.6087 81.7735C60.129 81.1205 59.6672 80.1552 58.8324 80.1504L52.7991 80.1156C51.9643 80.1108 51.4915 81.0707 52.0041 81.7296L54.9986 85.5786Z",
    fill: "#C5AAAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.1389 56.6897L62.8625 45.8973L67.4628 47.8158L62.1389 56.6897Z",
    fill: "#676767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.0303 56.1615L43.7928 46.6974L48.699 45.8184L49.0303 56.1615Z",
    fill: "#676767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.3398 68.2766L61.1569 46.3216C61.1569 46.3216 58.0829 45.3364 55.8826 45.2347C53.6823 45.133 49.8884 45.8007 49.8884 45.8007L55.3398 68.2766Z",
    fill: "#676767"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_622_3",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 36,
    y: 87,
    width: 38,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.4216 100.438C71.2818 102.153 69.2871 103.704 66.0355 104.674C65.1361 104.942 64.2297 104.347 64.0341 103.429L63.795 102.307C63.731 102.006 63.9228 101.711 64.223 101.648C67.0998 101.039 68.6285 99.8759 69.4065 98.7056C70.1895 97.5278 70.2633 96.2666 70.0874 95.3722C69.9112 94.4764 69.3016 93.1693 68.0523 92.2385C66.8229 91.3227 64.9139 90.7266 62.0408 91.3346L61.4969 91.4497L38.0856 96.3638C37.193 96.5512 36.3172 95.9803 36.1284 95.088C35.9395 94.1951 36.5098 93.3179 37.4027 93.1284L60.8059 88.1613C65.1147 87.2496 68.1696 88.1187 70.2273 89.6517C72.2651 91.1699 73.266 93.2953 73.5648 94.8147C73.864 96.3353 73.7376 98.4586 72.4216 100.438Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_622_3)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4216 100.438C71.2818 102.153 69.2871 103.704 66.0355 104.674C65.1361 104.942 64.2297 104.347 64.0341 103.429L63.795 102.307C63.731 102.006 63.9228 101.711 64.223 101.648C67.0998 101.039 68.6285 99.8759 69.4065 98.7056C70.1895 97.5278 70.2633 96.2666 70.0874 95.3722C69.9112 94.4764 69.3016 93.1693 68.0523 92.2385C66.8229 91.3227 64.9139 90.7266 62.0408 91.3346L61.4969 91.4497L38.0856 96.3638C37.193 96.5512 36.3172 95.9803 36.1284 95.088C35.9395 94.1951 36.5098 93.3179 37.4027 93.1284L60.8059 88.1613C65.1147 87.2496 68.1696 88.1187 70.2273 89.6517C72.2651 91.1699 73.266 93.2953 73.5648 94.8147C73.864 96.3353 73.7376 98.4586 72.4216 100.438Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_622_3",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 80,
    width: 44,
    height: 27
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 78.0781,
    y: 89.5092,
    width: 18.3748,
    height: 40.4083,
    rx: 2,
    transform: "rotate(103.155 78.0781 89.5092)",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_622_3)"
  }, /*#__PURE__*/React.createElement("line", {
    y1: -2.5,
    x2: 25.1501,
    y2: -2.5,
    transform: "matrix(-0.740383 -0.672185 0.992027 -0.126027 80.0667 100.317)",
    stroke: "#F87171",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    y1: -2.5,
    x2: 25.1501,
    y2: -2.5,
    transform: "matrix(-0.740383 -0.672185 0.992027 -0.126027 88.1926 98.9788)",
    stroke: "#F87171",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    y1: -2.5,
    x2: 46.5985,
    y2: -2.5,
    transform: "matrix(-0.736044 -0.676934 0.992632 -0.121165 79.988 108.825)",
    stroke: "#F87171",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    y1: -2.5,
    x2: 46.5985,
    y2: -2.5,
    transform: "matrix(-0.736044 -0.676934 0.992632 -0.121165 70.5552 109.069)",
    stroke: "#F87171",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    y1: -2.5,
    x2: 46.5985,
    y2: -2.5,
    transform: "matrix(-0.736044 -0.676934 0.992632 -0.121165 61.1226 109.312)",
    stroke: "#F87171",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    y1: -2.5,
    x2: 46.5985,
    y2: -2.5,
    transform: "matrix(-0.736044 -0.676934 0.992632 -0.121165 51.6899 109.554)",
    stroke: "#F87171",
    strokeWidth: 5
  })))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 52.0183,
    cy: 88.5486,
    rx: 4,
    ry: 3,
    fill: "#8A8A8A"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 59.0183,
    cy: 88.5486,
    rx: 4,
    ry: 3,
    fill: "#8A8A8A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2999 20.4309L64.0492 20.4308L67.0584 50.7754C57.4974 53.5546 52.8542 52.626 43.1818 47.8261L56.2999 20.4309Z",
    fill: "#3DB187"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56.8272 32.094C54.5723 26.167 61.7333 14.8178 67.264 17.4052C71.1288 19.2133 70.2763 22.85 68.8661 25.1431",
    stroke: "#3DB187",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_622_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.3756 46.9279C40.6607 45.2957 42.215 44.2038 43.8471 44.4889L67.1145 48.5537C68.7466 48.8388 69.8386 50.3931 69.5535 52.0252L69.5173 52.2322C69.2536 53.7418 67.8913 54.8111 66.3624 54.7069C57.2757 54.088 51.3314 53.4727 42.3114 50.5952C40.9055 50.1467 40.0628 48.7183 40.3167 47.2646L40.3756 46.9279Z",
    fill: "#34D399"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7722 42.4289C44.0297 42.1547 44.4865 42.2523 44.6093 42.608L45.8645 46.2425C45.9916 46.6104 45.668 46.9761 45.2873 46.8946L41.4 46.0632C41.0194 45.9818 40.8736 45.5158 41.1401 45.232L43.7722 42.4289Z",
    fill: "#34D399"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2632 43.0661C48.5207 42.7919 48.9774 42.8896 49.1003 43.2452L50.3555 46.8797C50.4825 47.2476 50.1589 47.6133 49.7783 47.5318L45.891 46.7004C45.5103 46.619 45.3646 46.153 45.6311 45.8692L48.2632 43.0661Z",
    fill: "#34D399"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7568 43.9106C53.0017 43.6251 53.4624 43.7021 53.6011 44.0518L55.0186 47.6262C55.1621 47.988 54.8553 48.3679 54.4713 48.3037L50.5506 47.648C50.1666 47.5838 50.0001 47.1248 50.2535 46.8293L52.7568 43.9106Z",
    fill: "#34D399"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6047 44.8336C57.8496 44.548 58.3103 44.625 58.449 44.9748L59.8665 48.5491C60.01 48.911 59.7032 49.2908 59.3192 49.2266L55.3985 48.5709C55.0145 48.5067 54.848 48.0478 55.1014 47.7523L57.6047 44.8336Z",
    fill: "#34D399"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2752 45.3508C62.4993 45.0486 62.9643 45.0928 63.1274 45.4318L64.7949 48.8966C64.9637 49.2474 64.6846 49.648 64.2971 49.6112L60.3397 49.2353C59.9522 49.1985 59.7535 48.7525 59.9853 48.4398L62.2752 45.3508Z",
    fill: "#34D399"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5516 46.4718C67.8069 46.1954 68.2644 46.2893 68.3902 46.6439L69.6753 50.2679C69.8054 50.6348 69.4849 51.0031 69.1035 50.9248L65.2095 50.1255C64.8282 50.0473 64.6786 49.5825 64.9428 49.2965L67.5516 46.4718Z",
    fill: "#34D399"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 68.3461,
    cy: 27.9458,
    r: 2.27437,
    fill: "#FBBF24"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_622_3",
    x: 36.2717,
    y: 40.4436,
    width: 37.3269,
    height: 18.2703,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_622_3"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_622_3",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_622_3",
    x1: 96.3225,
    y1: 118.962,
    x2: 78.8546,
    y2: 193.269,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A0A0A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#979797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_622_3",
    x1: 55.1182,
    y1: 119.758,
    x2: 60.9813,
    y2: 205.747,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#818181"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_622_3",
    x1: 51.5119,
    y1: 77.0942,
    x2: 60.7138,
    y2: 207.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#747474"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.369792,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFAFAF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_622_3",
    x1: 53.8771,
    y1: 43.4435,
    x2: 55.298,
    y2: 99.5726,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#989898"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868686"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChristmasScribbles);
export default __webpack_public_path__ + "static/media/christmas-scribbles.e93f9162045502c5a4c9753d6a4613de.svg";
export { ForwardRef as ReactComponent };